import React from 'react';

function Home({ setActiveTab }) {

  return (
    <div className="tab-content" style={{ position: 'relative', paddingBottom: '80px' }}>
      <div style={{ textAlign: 'center', marginBottom: '50px', padding: '20px' }}>
        <h1 style={{ color: '#2c3e50', fontSize: '42px', marginBottom: '20px', letterSpacing: '0.5px', fontWeight: '600' }}>
          Your Trusted Partner in Research Integrity
        </h1>
        <p style={{ fontSize: '20px', lineHeight: '1.8', color: '#555', maxWidth: '900px', margin: '0 auto' }}>
          World's first central accreditation and research support forum
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '20px' }}>
          Our Mission
        </h2>
        <p style={{ fontSize: '16px', lineHeight: '1.8' }}>
          To protect students and customers from fraud, verify genuine service providers, provide legal support,
          and promote ethical research through accreditation.
        </p>
      </div>

      <div style={{ marginBottom: '40px' }}>
        <h2 style={{ color: '#2c3e50', borderBottom: '2px solid #3498db', paddingBottom: '10px', marginBottom: '30px' }}>
          Key Actions
        </h2>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '25px' }}>
          <div
            onClick={() => setActiveTab('registered')}
            style={{
              padding: '25px',
              backgroundColor: '#e8f8f5',
              borderRadius: '10px',
              textAlign: 'center',
              border: '2px solid #27ae60',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: 'scale(1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(39, 174, 96, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <h3 style={{ color: '#27ae60', fontSize: '22px', marginBottom: '15px' }}>
              Verify
            </h3>
            <p style={{ fontSize: '15px', lineHeight: '1.6' }}>
              Check provider authenticity through our verified directory
            </p>
          </div>

          <div
            onClick={() => setActiveTab('complaint')}
            style={{
              padding: '25px',
              backgroundColor: '#ffebee',
              borderRadius: '10px',
              textAlign: 'center',
              border: '2px solid #e74c3c',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: 'scale(1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(231, 76, 60, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <h3 style={{ color: '#e74c3c', fontSize: '22px', marginBottom: '15px' }}>
              Report
            </h3>
            <p style={{ fontSize: '15px', lineHeight: '1.6' }}>
              File complaints against fraudulent providers
            </p>
          </div>

          <div
            onClick={() => setActiveTab('register-provider')}
            style={{
              padding: '25px',
              backgroundColor: '#e3f2fd',
              borderRadius: '10px',
              textAlign: 'center',
              border: '2px solid #2980b9',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              transform: 'scale(1)'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(41, 128, 185, 0.3)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            <h3 style={{ color: '#2980b9', fontSize: '22px', marginBottom: '15px' }}>
              Register
            </h3>
            <p style={{ fontSize: '15px', lineHeight: '1.6' }}>
              Providers can apply for accreditation and verification
            </p>
          </div>
        </div>
      </div>

      {/* Recent Grants notice board - disabled */}

    </div>
  );
}

export default Home;
